/*
  价格监控
  @date 2021-03-11
  @author wanghui@gwdang.com
 */
import PriceMonitor from '../../Model/PriceMonitor';

function validateSite(url) {
    const site_list = [
        'taobao.com',
        'tmall.com',
        'juhuasuan.com',
        'tb.com',
        'tb.cn',
        'tmall.hk',
        'zmnxbc.com',
        'yukhj.com',
        'jd.com',
        'jd.hk',
        'suning.com',
        'suning.cn',
        'gome.com',
        'gomeplus.com',
        'kaola.com',
        'dangdang.com',
        '.amazon.',
    ];

    let ret = false;
    site_list.forEach(function (item) {
        if (! ret && url.indexOf(item) !== -1) {
            ret = true
        }
    });

    return ret
}

const LinkItem = {
    props: ['link','id', 'showdel'],
    data: function () {
        return {
            placeholder: '请输入单品链接，如：https://item.jd.com/6373855.html',
            value: this.link.value,
            title: this.link.title,
        }
    },
    template: `<li class="link-item" :id="id" :data-ismatched="link.is_matched">
                            <input v-if="link.title" type="text" :value="link.title" disabled>
                            <input v-else v-model="value" type="text" :placeholder="placeholder" @focusout="input">
                            <span v-if="showdel" class="delete" @click="itemdelete">删除</span>
                            <div class="status" :class="{active: link.is_matched != 0}">
                                <i class="icon" :class="{'i-success': link.is_matched == 1, 'i-danger': link.is_matched != 1}"></i>
                                <span class="txt" v-if="link.is_matched == -1">抱歉，此商品不在平台监控范围</span>
                                <span class="txt" v-else-if="link.is_matched == -2">请输入正确的链接</span>
                                <span class="txt" v-else-if="link.is_matched == -3">链接重复，请输入新的商品链接</span>
                            </div>
                        </li>`,
    methods: {
        input: function (e) {
            this.$emit('item-change', e.target.value.trim(), this.id)
        },
        itemdelete: function (e) {
            this.$emit('item-delete', this.id)
        }
    },
    watch: {
        title: function (newV, oldV) {
            console.log(newV, oldV)
        }
    }
};

new Vue({
    el: '#app',
    data: {
        links: [
            {
                value: '',
                dp_id: '',
                title: '',
                is_matched: 0,
                time: (new Date()).getTime() + 100,
            },
            {
                value: '',
                dp_id: '',
                title: '',
                is_matched: 0,
                time: (new Date()).getTime() + 200,
            },
            {
                value: '',
                dp_id: '',
                title: '',
                is_matched: 0,
                time: (new Date()).getTime() + 300,
            },
        ],
        email: {
            value: '',
            validated: 0
        },
        yzm: {
            value: '',
            validated: 0,
            src: '/do/seccode/?rand='+Math.random(),
            validate_msg: '',
        },
        success: false,
        task_id: '',
        loading: false,
    },
    components: {LinkItem},
    methods: {
        async itemChange (d, id) {
            d = d.trim()
            this.links[id].value = d
            if (this.links[id] !== undefined) {
                if (d) {
                    if (d.indexOf('http') === -1) {
                        this.links[id].is_matched = -2;
                    } else {
                        if (!validateSite(d)) {
                            this.links[id].is_matched = -1;
                        } else {
                            let t = this.links.filter(function (link) {
                                return link.value == d
                            });
                            // 重复
                            if (t.length > 1) {
                                this.links[id].is_matched = -3;
                                this.links[id].value = d.trim()
                            } else {
                                this.links[id].is_matched = 0;
                                try {
                                    const res = await PriceMonitor.checkUrl(d);
                                    this.links[id].is_matched = res.pass;
                                    if (res.dp_info.dp_id == -1) {
                                        this.links[id].is_matched = -2
                                    }
                                    if (this.links[id].is_matched == 1) {
                                        this.links[id].dp_id = res.dp_info.dp_id;
                                        this.links[id].title = res.dp_info.title;
                                    }
                                } catch (err) {
                                    console.error(err)
                                }
                            }
                        }
                    }
                } else {
                    this.links[id].is_matched = 0;
                    this.links[id].value = ''
                    this.links[id].title = ''
                }
            }
        },
        itemDelete: function (id) {
            if (this.links.length > 1) {
                this.links = this.links.filter(function (link, index) {
                    return index !== id
                })
            }
        },
        addLink: function () {
            if (this.links.length >= 10) {
                return ;
            }
            this.links.push({
                value: '',
                dp_id: '',
                title: '',
                is_matched: 0,
                time: (new Date()).getTime(),
            })
        },
        updateYZM: function () {
            this.yzm.src = '/do/seccode/?rand='+Math.random()
        },
        async submit () {
            if (this.loading || this.yzm.validated) {
                return false;
            }

            let all_validated = true;
            let validated_links = [];
            let not_empty_links = [];
            not_empty_links = this.links.filter(function (link) {
                return link.value.trim()
            });
            validated_links = this.links.filter(function (link) {
                return link.value.trim() && Number(link.is_matched) === 1
            });

            if (! not_empty_links.length) {
                this.links[0].is_matched = -2;
            }

            not_empty_links.forEach(function (link) {
                if (link.is_matched === -3) {
                    all_validated = false
                }
            })

            if (validated_links.length) {
                if (not_empty_links.length !== validated_links.length) {
                    all_validated = false
                }
            } else {
                all_validated = false;
            }

            if (! this.email.value.trim()) {
                this.email.validated = -2;    // 空
                all_validated = false
            }

            if (! this.yzm.value.trim().length) {
                this.yzm.validated = -2;    // 空
                this.yzm.validate_msg = '验证码不能为空';
                all_validated = false
            }

            if (! all_validated) {
                let focused = false
                document.querySelectorAll('.link-item').forEach(function (item) {
                    if (! focused && item.getAttribute('data-ismatched') < 0) {
                        item.querySelector('input').focus()
                        focused = true;
                    }
                })
                return
            } else {
                // submit
                let sub_links = [];
                validated_links.forEach(function (item) {
                    sub_links.push(item.value)
                });

                this.loading = true;

                try {
                     const res = await PriceMonitor.submit({
                        action: 'submit',
                        email: this.email.value,
                        yzm: this.yzm.value,
                        links: sub_links.join(',')
                    });
                    this.success = true;
                    this.task_id = res.taskId
                } catch (error) {
                    if (error.validated == -2) {
                        this.yzm.validated = -2;
                        this.yzm.validate_msg = '验证码错误';
                        this.updateYZM();
                    }
                    if (error.validated == -1) {
                        this.email.validated = -1
                    }
                } finally {
                    this.loading = false;
                }
            }
        },
    },
    watch: {
        'email.value': function (newV) {
            const reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
            if (! newV) {
                this.email.validated = -1;
            } else if (! reg.test(newV)) {
                this.email.validated = -1;
            } else {
                this.email.validated = 1;
            }
        },
        'yzm.value': function (newV) {
            if (newV.trim().length){
                this.yzm.validated = 0;
            } else {
                this.yzm.validated = -2;
                this.yzm.validate_msg = '验证码不能为空';
            }
        }
    }

});

